import React from 'react';
import { Button, Paper } from '@mui/material';
import { Redo, Undo } from '@mui/icons-material';
import chartingMenuSx from './ChartingMenu.styles';
import { useTheme } from '@mui/material/styles';
import MenuLayers from './MenuLayers';
import MenuTeeth from './MenuTeeth';
import MenuMarkup from './MenuMarkup';
import MenuDeleteMove from './MenuDeleteMove';
import MenuExtras from './MenuExtras';
import MenuSymbols from './MenuSymbols';
import AllSymbolsDialog from './AllSymbolsDialog';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../Chart.redux';
import MenuSave from './MenuSave';

const ChartingMenu = () => {
    const theme = useTheme();
    const sx = chartingMenuSx(theme);
    const dispatch = useDispatch();
    const saving = useSelector((state) => state.chart.saving);
    const canUndo = useSelector((state) => state.chart.history.present > 0);
    const canRedo = useSelector((state) => {
        const history = state.chart.history;
        return history.present + 1 < history.available.length;
    });

    return (
        <Paper elevation={2} sx={sx.menuContainer}>
            <MenuLayers />
            <MenuTeeth />
            <MenuSymbols />
            <MenuMarkup />
            <MenuExtras />
            <MenuDeleteMove />
            <AllSymbolsDialog />

            <Button
                variant="outlined"
                sx={{ ...sx.buttonMarginRight, ...sx.buttonFloat, ...sx.buttonSmall }}
                disabled={!canUndo}
                onClick={() => dispatch(actions.undoRedo('UNDO'))}
            >
                <Undo />
            </Button>

            <Button
                variant="outlined"
                sx={{ ...sx.buttonMarginRight, ...sx.buttonFloat, ...sx.buttonSmall }}
                disabled={!canRedo}
                onClick={() => dispatch(actions.undoRedo('REDO'))}
            >
                <Redo />
            </Button>

            <MenuSave saving={saving} />
        </Paper>
    );
};

export default ChartingMenu;
